import React,{useState,useEffect} from 'react';



function Logout() {

    useEffect(() => {
            localStorage.removeItem("jwt")
            localStorage.removeItem("userInfo")
            localStorage.removeItem("token")
            setTimeout(()=>{
                window.location.replace("/login");
            })
     }, []);

    return (
        <div>
            Loading....
        </div>
    )
}

export default Logout
